import { render, staticRenderFns } from "./display-field-icon.vue?vue&type=template&id=060e11e8&scoped=true&"
import script from "./display-field-icon.ts?vue&type=script&lang=ts&"
export * from "./display-field-icon.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-icon.scss?vue&type=style&index=0&id=060e11e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e11e8",
  null
  
)

export default component.exports